import { Link } from "react-router-dom";
import styled from "styled-components";

export const ProfileNavbarBackground = styled.header`
  position: relative;
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
`;

export const ProfileNavbarLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const VerticleLine = styled.div`
  width: 1px;
  height: 40px;
  background: #fe638d;
  margin: 0 1rem;
`;

export const ProfilePicture = styled.img`
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 50%;
`;

export const ProfileSearchbar = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  margin: 0.5rem 1rem;
`;

export const SearchBarDiv = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 500px;
  border: 2px solid #fe2f67;
  border-radius: 10px;
  padding: 0.3rem 0.8rem;

  @media (max-width: 600px) {
    max-width: 300px;
  }
`;

export const ProfileSearch = styled.div.attrs({
  placeholderTextColor: "#FE2F67",
})`
  flex: 1;
  border: none;
  outline: none;
  caret-color: #9ba9c0;
  color: #fe2f67;
  font-size: 1rem;
  font-family: "Inter", sans-serif;
  margin-left: 0.5rem;
  background: transparent;
`;

export const ProfileIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-left: auto;
  justify-content: space-between;
  margin-right: 3%;
`;

export const Icons = styled.p`
  cursor: pointer;
`;
export const LogoButton = styled(Link)`
  display: flex;
  align-items: center;
  border-radius: 12px;
  padding: 4px;
  transition: transform 0.18s ease, box-shadow 0.18s ease;

  &:hover {
    transform: translateY(-2px) scale(1.04);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }

  &:focus-visible {
    outline: 2px solid #fe2f67;
    outline-offset: 2px;
  }
`;

export const NavIcon = styled.button`
  appearance: none;
  border: none;
  background: transparent;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;

  transition: background 0.18s ease, transform 0.18s ease;

  svg {
    font-size: 26px;
    color: #fe2f67;
  }

  &:hover {
    background: rgba(254, 47, 103, 0.12);
    transform: scale(1.08);
  }

  &:focus-visible {
    outline: 2px solid #fe2f67;
    outline-offset: 2px;
  }
`;
